module.exports = __webpack_public_path__ + "static/media/pcb.1b716277.jpg";